<script lang="ts" setup>
import DirectionColumnIfMobileContainer from '../../DirectionColumnIfMobileContainer.vue';
import ResearchDataCard from '../../ResearchData/ResearchDataCard.vue';
import Img1 from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/mortgage/ResearchDataCard/3_1.jpeg/3_1.webp';
import Img2 from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/mortgage/ResearchDataCard/3_2.jpeg/3_2.webp';
import PinchImageModal from '~theme/components/organisms/PinchImageModal.vue';

defineProps<{
  num: number;
}>();
</script>

<template>
  <ResearchDataCard :num="num" :class="$style.container">
    <template #title>
      マイホームは<strong
        >「新築戸建て（注文）」が最も人気！平均購入金額は「新築マンション」が最も高い結果に</strong
      >
    </template>
    <DirectionColumnIfMobileContainer>
      <PinchImageModal :src="Img1" alt="グラフ" />
      <div>
        <p>
          既にマイホームを所有している方へ「購入した物件タイプ」について質問したところ、
          <strong>「新築戸建て（注文）」が43.1％と最も多い結果</strong
          >となりました。
        </p>
      </div>
    </DirectionColumnIfMobileContainer>
    <DirectionColumnIfMobileContainer>
      <PinchImageModal :src="Img2" alt="グラフ" />
      <div>
        <p>
          さらに、「購入した物件タイプ」別の「物件価格（土地代含む）」平均金額を調べると、
          <strong>新築マンションが約3,900万円</strong
          >と最も高い結果となりました。
        </p>
      </div>
    </DirectionColumnIfMobileContainer>
  </ResearchDataCard>
</template>

<style lang="scss" module>
.container {
  :nth-child(n + 2) {
    margin-top: 8px;
  }
}
</style>
